module.exports = __webpack_public_path__ + "img/home.d3355134.png";